import { render, staticRenderFns } from "./task-attachments.vue?vue&type=template&id=3514b560"
import script from "./task-attachments.vue?vue&type=script&lang=js"
export * from "./task-attachments.vue?vue&type=script&lang=js"
import style0 from "./task-attachments.vue?vue&type=style&index=0&id=3514b560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports